import { z } from 'zod';

const DATA_BEACON = 'data-narvar-beacon';

const BeaconAttributesSchema = z
  .object({
    id: z.string(),
    label: z.string().optional(),
  })
  .passthrough();

export function parseBeacon(target) {
  const maybeBeaconData = target
    .closest(`[${DATA_BEACON}]`)
    ?.getAttribute(DATA_BEACON);
  if (!maybeBeaconData) return undefined;

  try {
    const beaconJson = JSON.parse(maybeBeaconData);
    return BeaconAttributesSchema.parse(beaconJson);
  } catch (e) {
    console.error('Error parsing beacon data', e);
    return undefined;
  }
}

export function beacon(attrs) {
  return { [DATA_BEACON]: JSON.stringify(attrs) };
}
